import React, {Component} from 'react';
import { Redirect } from 'react-router-dom';
import { Modal } from 'reactstrap';
import { unmountComponentAtNode } from "react-dom";
import {base, appDatabasePrimaryFunctions} from '../../base';
import { confirmAlert } from '../utils/react-confirm-alert';
import AnswerItemsComponent from '../../components/small_components/AnswerItemsComponent';
import Confetti from 'react-confetti';
import appBackgroundImage from '../../styles/images/trivia_background.png'
import sampleAppFrontImage from '../../styles/images/front_icon.png'
import sampleSponsorLogo from '../../styles/images/sponsor_logo.png'
import sampleAppTopImage from '../../styles/images/top_icon.png';
import ReactPlayer from 'react-player';
import '../../styles/css/react-confirm-alert.css';
import '../../styles/css/Home.css';
import '../../styles/css/ConfirmAlertCustom.css';
import '../../styles/css/main.css';
import '../../styles/css/CreatorAwards.css';


class Main_App extends Component {
    constructor(props) {
        super(props);
        this.state = {
          userEmail: localStorage.getItem('userEmail') || false,
          alerted: false,
          // answerList: [],
          gameActive: false,
          fullName: '',
          seenVideo: false,
          phone: '',
          zip: '',
          tenantRules: {},
          question: 0,
          width: 0,
          height: 0,
          questions: [],
          questionAnswered: false,
          formFilledOut: false,
          videoDuration: "0:00",
          userAnswers: [],
          alreadyUpdate: "",
          currentGameId: null,
          currentTiviaGameTime: false,
          currentResponseArray: [],
          startConfetti: false,
          rotationStarted: false,
          optedIntoEmail: {},
          tierMessaging: []
        };
        this.logout = this.logout.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
        this.toggle = this.toggle.bind(this);
        this.onEnded = this.onEnded.bind(this);
    }

    removeReactAlert(){
      document.body.classList.remove('react-confirm-alert-body-element');
      const target = document.getElementById('react-confirm-alert');
      if(target){
        unmountComponentAtNode(target);
        target.parentNode.removeChild(target)
      }
      const svg = document.getElementById('react-confirm-alert-firm-svg');
      if(svg){
        svg.parentNode.removeChild(svg);
        document.body.children[0].classList.remove('react-confirm-alert-blur')
      }
    }

    componentDidMount() {
      if(!navigator.cookieEnabled){
        alert("You do not have cookies enabled! Please change the settings of your browser");
        return;
      }

      this.currentTriviaGameKeyRef = base.listenTo(`currentTriviaGame/id`, {
        context: this,
        then(key){
          if(typeof key === "string"){
            this.logUserActivity(key);
            this.removeReactAlert();
            this.setState({
              currentGameId:key,
              startConfetti: false
            }, ()=> {
              this.currentGameFormFilledRef = base.listenTo('currentGameFormFilled/'+ this.state.currentGameId +'/' +base64EncodedEmail, {
                context: this,
                state: 'formFilledOut',
                then(response){
                  if(response.name){
                    document.getElementById('more-info-form').style.display = "none";
                    document.getElementById('thanks-for-playing-section').style.display = ""
                  }
                }
              })
            })
          }
        }
      });

      this.tenantRulesRef = base.bindToState(`tenantRules`, {
        context: this,
        state: 'tenantRules',
      });
      const userEmail = this.state.userEmail;
      const base64EncodedEmail = btoa(userEmail);

      this.gameActiveRef = base.bindToState('currentTriviaGame/active', {
        context: this,
        state: 'gameActive',
      })

      // this.questionAnsweredRef = base.bindToState('currentTriviaGame/answered', {
      //   context: this,
      //   state: 'questionAnswered',
      // })

      this.gameStartTime = base.bindToState('currentTriviaGame/timeStamp', {
        context: this,
        state: 'currentTiviaGameTime',
      })

      this.rotationStartedRef = base.bindToState('currentTriviaGame/rotate', {
        context: this,
        state: 'rotationStarted',
      })

      this.tierMessagingRef = base.bindToState('tierMessaging', {
        context: this,
        state: 'tierMessaging',
      });

      this.questionRef = base.bindToState('currentTriviaGame/questions', {
        context: this,
        state: 'questions',
        asArray: true
      });

      this.userAnswersRef = base.bindToState("userAnswers", {
        context: this,
        state: 'userAnswers',
        asArray: true
      });

      this.currentResponseArrayRef = base.listenTo('userAnswers/'+base64EncodedEmail, {
        context: this,
        state: 'currentResponseArray',
        asArray: true,
        then(arrayOfAnswers){
          let numberOfAnswers = arrayOfAnswers.length;
          let questionAnswered = false;
          let hasVideoUrl = false;
          if(numberOfAnswers > 0){
            numberOfAnswers = numberOfAnswers - 1;
            if(numberOfAnswers === this.state.questions.length){
              questionAnswered = true;
            } else {
              hasVideoUrl = !!this.state.questions[numberOfAnswers].videoLink;
            }
          }
          this.setState({
            questionAnswered: questionAnswered,
            question: numberOfAnswers,
            currentResponseArray: arrayOfAnswers,
            modal: hasVideoUrl
          })
        }
      });

      this.prizesWonRef = base.listenTo('prizeWon/'+base64EncodedEmail, {
        context: this,
        then(winnerPrize){
          if(winnerPrize === true){
            this.showGameOverMessage(true)
          } else if(winnerPrize === false) {
            this.showGameOverMessage(false)
          }
        }
      });

      this.updateWindowDimensions();
      window.addEventListener('resize', this.updateWindowDimensions);
      window.scrollTo(0,0)
    }

    onEnded(){
      this.setState({
        modal: false
      })
    }

    handleChange(event) {
      this.setState({[event.target.name]: event.target.value});
    }

    componentWillUnmount() {
      base.removeBinding(this.rotationStartedRef);
      base.removeBinding(this.currentTriviaGameKeyRef);
      base.removeBinding(this.tierMessagingRef);
      base.removeBinding(this.currentResponseArrayRef);
      base.removeBinding(this.tenantRulesRef);
      base.removeBinding(this.questionRef);
      base.removeBinding(this.userAnswersRef);
      if(this.currentGameFormFilledRef){
        base.removeBinding(this.currentGameFormFilledRef);
      }
      base.removeBinding(this.gameActiveRef);
      window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions() {
      this.setState({ width: window.innerWidth, height: window.innerHeight });
    }

    logout(){
      localStorage.removeItem('userEmail');
      this.setState({
        userEmail:false
      })
    }

    setUpQuestionsWithAnswerCount(userAnswers, questions){
      let finalQuestionTally = {};
      let questionIdArray = [];
      for(let questionIndex in questions){
        let question = questions[questionIndex];
        let questionId = question.id;
        finalQuestionTally[questionId] = {};
        finalQuestionTally[questionId].totalPicks = 0;
        finalQuestionTally[questionId].answers = {};
        let questionAnswers = question.answers;
        for(let answerIndex in questionAnswers){
          let answer = questionAnswers[answerIndex];
          let answerId = answer.id;
          finalQuestionTally[questionId].answers[answerId] = 0;
        }
        questionIdArray.push(questions[questionIndex].id);
      }
      if(userAnswers.length > 0) {
        for(let answerIndex in userAnswers) {
          let answerObject = userAnswers[answerIndex];
          for(let questionIndex in questionIdArray){
            let questionId = questionIdArray[questionIndex];
            if(answerObject[questionId]){
              finalQuestionTally[questionId].totalPicks++;
              let answerId =  answerObject[questionId];
              finalQuestionTally[questionId].answers[answerId]++;
            };
          }
        }
      }
      return finalQuestionTally;
    }

    showGameOverMessage(gotWinningMessage){
      const currentAnswerArray = this.state.currentResponseArray;
      const questions = this.state.questions;
      const answers = [];
      for(const y in questions){
        const questionAnswers = questions[y].answers;
        for(const answerIndex in questionAnswers){
          if(currentAnswerArray.indexOf(questionAnswers[answerIndex].id) != -1){
            questionAnswers[answerIndex].shown =  questions[y].shown;
            answers.push(questionAnswers[answerIndex])
          }
        }
      }
      let count = 0;
      for(const answerIndex in answers){
        const answer = answers[answerIndex];
        if(answer.correct){
          count+=1
        }
      }
      const tierMessages = this.state.tierMessaging[count];
      let headerHeader = tierMessages.losingHeader;
      let headerMessage = tierMessages.losingMessage;
      if(gotWinningMessage){
        headerHeader = tierMessages.winningHeader;
        headerMessage = tierMessages.winningMessage;
        this.setState({
          startConfetti: true
        })
      } else if (count > 0) {
        headerHeader = tierMessages.winningMissedHeader;
        headerMessage = tierMessages.winningMissedMessage;
        // this.setState({
        //   startConfetti: true
        // })
      }
      confirmAlert({
        variables: this.props.variables,
        title: headerHeader,
        message: headerMessage,
        buttons: [
          {
            label: 'OK',
            onClick: () => this.setState({startConfetti:false})
          }
        ]
      })
    }

    logUserActivity(currentGame){
      const vm = this;
      if(currentGame){
        const gameid = currentGame;
        const userEmailToBase64 = btoa(this.state.userEmail);
        base.post('userGameHistory/'+userEmailToBase64+`/${gameid}` , {
          data:gameid,
          then(err){
            if(!err){
              vm.setState({
                alreadyUpdate: gameid,
              })
              console.log("user game logged!")
            }
          }
        })
      }
    }

    toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

    onClickAnswer(answerClicked, position){
      const gridItem = document.getElementById(answerClicked.id);
      if(typeof this.state.currentGameId === "string" && this.state.currentGameId.length > 0){
          this.logUserActivity(this.state.currentGameId);
      }
      // gridItem.style.backgroundColor = localStorage.getItem('primaryColor');
      if(this.state.rotationStarted){
        confirmAlert({
          variables: this.props.variables,
          title: 'Answers showing on scoreboard',
          message: "Can't pick an answer once the scoreboard has started showing them",
          buttons: [
            {
              label: 'OK',
              // onClick: () => gridItem.style.backgroundColor = "transparent"
            }
          ]
        })
        return
      }
      var answerInfo = {};
      // document.getElementsByClassName("grid")
      // document.getElement react-confirm-alert-button-group button
      answerInfo['answerText'] = answerClicked.answerText;
      answerInfo['position'] = position;
      answerInfo['questionId'] = "questionID"
      answerInfo['answerId'] = answerClicked.id;
      answerInfo['timeAnswered'] = Date.now();
      answerInfo['email'] = this.state.userEmail;

      // if(this.state.userEmail.trim() === ""){
      //   alert("This email is strange, please logout and try a different one!")
      //   return;
      // }
      // if(this.state.currentResponse.answerId){
      //   confirmAlert({
      //     title: 'Answer already picked!',
      //     message: "You already have an answer selected so you can't pick another one",
      //     buttons: [
      //       {
      //         label: 'OK',
      //       }
      //     ]
      //   })
      //   return;
      // }
      // this.setState({
      //   currentResponse: answerInfo
      // })
      var base64EncodedEmail = btoa(this.state.userEmail);

      var vm = this;
      var questionId = this.state.questions[this.state.question].id;
      var postToUserAnswers = {};
      // https://stackoverflow.com/questions/37954217/is-the-way-the-firebase-database-quickstart-handles-counts-secure/37956590#37956590
      // one day when you want to refactor this with less data being passed around via user answers check out this article on
      // not a perfect solution since I think it could have a higher failure rate on update but if handled well maybe this makes more sense
      // although the more people voting the more failures it would have so a little counter intuitive
      postToUserAnswers["/userAnswers/" + base64EncodedEmail + "/" + questionId] = answerClicked.id;
      postToUserAnswers["/userAnswers/" + base64EncodedEmail + '/timeStamp'] = new Date().getTime().toString();
      // base.post(`userAnswers/${base64EncodedEmail}/${questionId}`, {
      appDatabasePrimaryFunctions.ref().update(postToUserAnswers, function(error){
        if(!error){
          console.log("Answer Clicked");
          // gridItem.style.backgroundColor = "transparent";
        } else {
          console.log(error)
          confirmAlert({
              variables: vm.props.variables,
              title: 'There was an error',
              message: error.message,
              buttons: [
                {
                  label: 'OK',
                }
              ]
            })
        }
      })
    }

    renderHoldingScreen(){
      const tenantVariables = this.props.variables || {};
      const frontLogoImage = tenantVariables.frontLogoImage || sampleAppFrontImage;
      const secondaryColor = tenantVariables.secondaryColor || "white";
      const primaryColor = tenantVariables.primaryColor || "black";
      const logOutButtonColor = tenantVariables.logOutButtonColor || "white";
      const questionTextColor = tenantVariables.questionTextColor || "white";

      return(
        <div className="flex-content-container-home">
          <div className="flex-header-home">
            <div className="header-left">
              <img className="topLeftLogo" alt=""/>
            </div>
            <div className="header-right">
              <button className="btn btn-logout" onClick={() => { this.logout() }} style={{color: logOutButtonColor, borderColor: logOutButtonColor}}>LOG OUT</button>
            </div>
          </div>
          <div className="intro-container-home" >
            <div className="hero-text-container">
              <img src={frontLogoImage} className="main-hero-image" alt=""/>
            </div>
            <p style={{display: tenantVariables.playingText ? '' : "none", color:questionTextColor}}>Next game starts during <br/><span className="emphasizedText" style={{backgroundColor:primaryColor, color:secondaryColor}}>{tenantVariables.playingText}</span></p>
          </div>
        </div>
        )
    }

    renderPlayingScreen(){
      const tenantVariables = this.props.variables || {};
      const questions = this.state.questions || [];
      let answerList = [];
      // var currentAnswerArray = this.state.currentResponseArray;
      let question = {};
      const topLeftImage = tenantVariables.topLeftImage || sampleAppTopImage;
      const logOutButtonColor = tenantVariables.logOutButtonColor || "white";
      const sponsorLogo = tenantVariables.sponsorLogo || sampleSponsorLogo;
      const questionTextColor = tenantVariables.fanQuestionColor || "white";
      let questionCount = [];
      let videoURL = "";
      if(questions.length > 0){
        const questionNumber = this.state.question;
        question = questions[questionNumber];
        answerList = questions[questionNumber].answers.sort((a,b)=>a.order-b.order);
        questionCount = this.setUpQuestionsWithAnswerCount(this.state.userAnswers, questions);
        videoURL = questions[questionNumber].videoLink;

      }
      return(
        <div className="flex-content-container-home">
          <div className="intro-container-home">
            <div className="flex-header-home" style={{justifyContent: "flex-end"}}>
              <div className="header-right">
                <button className="btn btn-logout" onClick={() => { this.logout() }} style={{color: logOutButtonColor, borderColor: logOutButtonColor}}>LOG OUT</button>
              </div>
            </div>
            <div className="grid-wrapper">
              <div className="creator-awards-logo-playscreen user"><img src={topLeftImage} alt="" style={{marginBottom:"0"}}/></div>
              <div className="card" style={{borderRadius:"20px", margin:'0',padding:'0'}}>
                <div className="top-text">
                    <p className="top-text-mobile" style={{wordWrap: "break-word", fontWeight:700, color:questionTextColor}}>{question.questionText}</p>
                </div>
                <AnswerItemsComponent question={question} answers={answerList} questionCount={questionCount} tenantVariables={tenantVariables} onClickAnswer={(item, i)=>this.onClickAnswer(item, i)}/>
                <div style={{width:"100%", textAlign: "center"}}>
                  <img width="100%" src={sponsorLogo} alt="" style={{maxWidth:"380px"}}/>
                </div>
                <div className="mobilehide" style={{height:"100px", width:"1px"}}/>
              </div>
            </div>
          </div>
          <Modal isOpen={(this.state.modal && videoURL)} style={{width: '90%'}} id="myModal" toggle={this.toggle}>
            <ReactPlayer config={{file: { attributes : { controlsList: 'nodownload', disablePictureInPicture:true} } }} controls={true} pip={false} playing={this.state.modal} url={videoURL} playsinline={true} muted={true} volume={0} onEnded={this.onEnded} width="100%" height="auto"/>
          </Modal>
        </div>
        )
    }

    handleSubmit(event){
      event.preventDefault();
      const zip = this.state.zip.trim();
      const name = this.state.fullName.trim();
      const phone = this.state.phone.trim();
      const timesubmitted = Date.now();
      const receive_emails = this.refs.want_emails.checked;
      if(!this.refs.agree_to_rules_regs.checked){
        confirmAlert({
          variables: this.props.variables,
          title: 'Missing Info',
          message: "Please agree to rules and regulations!",
          buttons: [
            {
              label: 'OK',
            }
          ]
        });
        return;
        }
      if(zip.length === 0 || name.length === 0 || phone === 0){
        confirmAlert({
          variables: this.props.variables,
          title: 'Missing Info',
          message: "Please fill out all information before submitting this form",
          buttons: [
            {
              label: 'OK',
            }
          ]
        });
        return;
      }
      const base64EncodedEmail = btoa(this.state.userEmail);
      const vm = this;
      const formData = {name: name, phone: phone, zip: zip, receive_emails: receive_emails, timeSubmitted: timesubmitted};
      base.post(`currentGameFormFilled/`+ this.state.currentGameId +'/' +base64EncodedEmail, {
        data: formData,
        then(err){
          if(!err){
            document.getElementById('more-info-form').style.display = "none";
            document.getElementById('thanks-for-playing-section').style.display = "";
          } else {
            console.log(err);
            confirmAlert({
                variables: vm.props.variables,
                title: 'There was an error',
                message: err.message,
                buttons: [
                  {
                    label: 'OK',
                  }
                ]
              })
          }
        }
      });
    }

    thanksForPlayingScreen(){
      const tenantVariables = this.props.variables || {};
      const currentAnswerArray = this.state.currentResponseArray;
      let questionCount = [];
      var currentTriviaGameTime = this.state.currentTiviaGameTime;
      var nowInMilli = Date.now();
      var hoursInMillisecnods24 = 86400000;
      var hideAnswerForm = false
      if(currentTriviaGameTime && (currentTriviaGameTime + hoursInMillisecnods24) < nowInMilli){
        hideAnswerForm = true
      }
      var questions = this.state.questions;
      var topAnswerImage = tenantVariables.topAnswerImage || sampleAppTopImage
      var sponsorLogo = tenantVariables.sponsorLogo || sampleSponsorLogo
      var primaryColor = tenantVariables.primaryColor || "black"
      var secondaryColor = tenantVariables.secondaryColor || "white"
      var logOutButtonColor = tenantVariables.logOutButtonColor || "white"
      var answers = [];
      for(var y in questions){
        var questionAnswers = questions[y].answers;
        for(var answer in questionAnswers){
          if(currentAnswerArray.indexOf(questionAnswers[answer].id) != -1){
            questionAnswers[answer].shown =  questions[y].shown;
            answers.push(questionAnswers[answer])
          }
        }
      }
      questionCount = this.setUpQuestionsWithAnswerCount(this.state.userAnswers, questions)
      return(
        <div className="flex-content-container-home">
          <div className="flex-header-home">
            <Confetti numberOfPieces={400} width={this.state.width} height={this.state.height} style={{display: this.state.startConfetti ? '' : 'none', zIndex: 1}}/>
            <div className="header-left">
              <img className="topLeftLogo" alt=""/>
            </div>
            <div className="header-right">
              <button className="btn btn-logout" onClick={() => { this.logout() }} style={{color: logOutButtonColor, borderColor: logOutButtonColor}}>LOG OUT</button>
            </div>
          </div>
          <center className="creator-awards-logo-playscreen user"><img src={topAnswerImage} alt="" style={{marginBottom:"0"}}/></center>
          <div className="intro-container-home" style={{marginTop:'20px'}}>
            <div className="top-text">
                <p className="top-text-mobile"><span className="emphasizedTextAnswers" style={{backgroundColor:primaryColor, color:secondaryColor}}>My Answers</span></p>
            </div>
            <AnswerItemsComponent answers={answers} questionCount={questionCount} tenantVariables={tenantVariables} onClickAnswer={()=>console.log("click")}/>
            <div className="container-out" id="more-info-form" style={{display: tenantVariables.formHeaderText === "" || hideAnswerForm || !tenantVariables.formHeaderText ? 'none': 'block'}}>
              <div className="question-box question-form" style={{padding:'15px'}}>
                <h4 style={{fontFamily: "Oswald", fontWeight: 700}}>{tenantVariables.formHeaderText}</h4>
                <form onSubmit={this.handleSubmit} id="user-values-form">
                  <div className="input-group">
                    <input id="fullName" name="fullName" type="text" style={{fontFamily: "Oswald"}} className="form-control" onChange={this.handleChange} placeholder="Full Name" />
                  </div>
                  <div className="input-group">
                    <input id="phone" name="phone" type="tel" style={{fontFamily: "Oswald"}} className="form-control" onChange={this.handleChange} placeholder="Phone" />
                  </div>
                  <div className="input-group">
                    <input id="zip" name="zip" type="text" pattern="[0-9]*" style={{fontFamily: "Oswald"}} className="form-control" onChange={this.handleChange} placeholder="Zip" />
                  </div>
                  <div className="checkbox" style={{padding:'5px'}}>
                    <label className="agree_to_rules_class"><input type="checkbox" ref="agree_to_rules_regs"/> I Agree To <a target="_blank" href={this.state.tenantRules.rulesAndRegsLink}>Rules And Regulations</a></label>
                  </div>
                  <div className="checkbox" style={{padding:'5px'}}>
                    <label className="want_emails"><input type="checkbox" ref="want_emails" defaultChecked/> I want to receive emails </label>
                  </div>
                  <button style={{backgroundColor: primaryColor, color: secondaryColor}} className="btn btn-play" id="submitButton"><strong>SUBMIT</strong></button>
                </form>
              </div>
            </div>
            <p id="thanks-for-playing-section" style={{color:secondaryColor, display:"none", marginTop:"5%"}}><span className="thanksForPlayingLittleText">Thanks for</span><br/><span className="emphasizedText" style={{backgroundColor:primaryColor, color:secondaryColor}}>Playing</span></p>
            <div style={{width:"100%", textAlign: "center", padding:"10px"}}>
              <img width="100%" src={sponsorLogo} alt="" style={{maxWidth:"380px", maxHeight:"280px"}}/>
            </div>
          </div>
        </div>
        )
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
      if(prevState.questionAnswered && !this.state.questionAnswered){
        this.removeReactAlert()
        this.setState({
          startConfetti:false
        })
      }
    }

    render() {
      const tenantVariables = this.props.variables || {};
      if(!this.state.userEmail){
        return (
            <Redirect to="/login" />
        )
      }
      let renderMainScreen = this.renderHoldingScreen()
       // && !this.state.currentResponse.id
      if(this.state.gameActive === true && !this.state.questionAnswered){
        renderMainScreen = this.renderPlayingScreen()
      } else if(this.state.questionAnswered === true){
        renderMainScreen = this.thanksForPlayingScreen()
      }
      const backgroundImage = tenantVariables.backgroundImage || appBackgroundImage;
      // else if(this.state.gameActive && !this.state.questionAnswered && this.state.currentResponse.id){
      //   renderMainScreen = this.playedWaitingScreen()
      // }
      return(
          <div className="flex-container-home" style={{backgroundImage: "url(" + backgroundImage + ")", scrollbarWidth:"none"}}>
            {renderMainScreen}
          </div>
      )
    }
}

export default Main_App;
